<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <form @submit.prevent="register">
        <signup-card>
          <h2 class="title text-center" slot="title">會員註冊</h2>
          <div
            class="md-layout-item md-size-50 md-medium-size-50 md-small-size-100 ml-auto"
            slot="content-left"
          >
            <div
              class="info info-horizontal"
              v-for="item in contentLeft"
              :key="item.title"
            >
              <div :class="`icon ${item.colorIcon}`">
                <md-icon>{{ item.icon }}</md-icon>
              </div>
              <div class="description">
                <h4 class="info-title">{{ item.title }}</h4>
                <p class="description">
                  {{ item.description }}
                </p>
              </div>
            </div>
          </div>
          <div
            class="md-layout-item md-size-50 md-medium-size-50 md-small-size-100 mr-auto"
            slot="content-right"
          >
            <md-field
              class="md-form-group md-invalid"
              style="margin-bottom: 2rem"
            >
              <md-icon>face</md-icon>
              <label>姓名</label>
              <md-input v-model="name" />
              <validation-error :errors="apiValidationErrors.name" />
            </md-field>

            <md-field
              class="md-form-group md-invalid"
              style="margin-bottom: 2rem"
            >
              <md-icon>fingerprint</md-icon>
              <label>手機號碼(登入帳號)</label>
              <md-input v-model="mobile" />
              <validation-error  :errors="apiValidationErrors.mobile" />
            </md-field>

            <md-field
              v-show="false"
              class="md-form-group md-invalid"
              style="margin-bottom: 2rem"
            >
              <md-icon>email</md-icon>
              <label>Email</label>
              <md-input v-model="email" />
              <validation-error :errors="apiValidationErrors.email" />
            </md-field>

            <md-field
              v-show="false"
              class="md-form-group md-invalid"
              style="margin-bottom: 2rem"
            >
              <md-icon>transgender</md-icon>
              <label>性別</label>
              <md-select v-model="sex" name="sex" id="sex" style="margin-left: 16px">
                <md-option value="0">女</md-option>
                <md-option value="1">男</md-option>
                <md-option value="2">不好說</md-option>
              </md-select>
              <validation-error :errors="apiValidationErrors.sex" />
            </md-field>

       

            <md-datepicker v-show="false" v-model="birthday" >
              <label>生日</label>
            </md-datepicker>

       

            <md-field
              class="md-form-group md-invalid"
              style="margin-bottom: 2rem"
            >
              <md-icon>lock_outline</md-icon>
              <label>密碼</label>
              <md-input v-model="password" type="password" />
              <validation-error :errors="apiValidationErrors.password" />
            </md-field>

            <md-field class="md-form-group md-invalid">
              <md-icon>lock_outline</md-icon>
              <label>確認密碼</label>
              <md-input v-model="password_confirmation" type="password" />
              <validation-error
                :errors="apiValidationErrors.password_confirmation"
              />
            </md-field>

            <md-checkbox v-model="boolean"
              >我同意遵守原來是洋蔥會員條款.</md-checkbox
            >

            <div class="button-container">
              <md-button
                class="md-success md-round mt-4"
                type="submit"
                slot="footer"
              >
                註冊
              </md-button>
            </div>
          </div>
        </signup-card>
      </form>
    </div>
  </div>
</template>
<script>
import { SignupCard, ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
import moment from "moment";

export default {
  components: {
    SignupCard,
    ValidationError,
  },
  mixins: [formMixin],
  data() {
    return {
      name: null,
      boolean: false,
      email: null,
      mobile: null,
      sex: null,
      birthday: new Date('12/01/1911'),
      password: null,
      password_confirmation: null,
      available_roles: [
        {
          id: 1,
          name: "Admin",
        },
        {
          id: 2,
          name: "Creator",
        },
        {
          id: 3,
          name: "Member",
        },
      ],
      contentLeft: [
        {
          colorIcon: "icon-success",
          icon: "accessibility",
          title: "隨時領",
          description:
            "健身後隨時領，即刻補充優質蛋白",
        },

      ],
    };
  },

  methods: {
    async register() {
      if (!this.boolean) {
        await this.$store.dispatch(
          "alerts/error",
          "同意會員條款才能註冊成為會員."
        );
        return;
      }

      const user = {
        data: {
          type: "token",
          attributes: {
            name: this.name,
            mobile: this.mobile,
            password: this.password,
            password_confirmation: this.password_confirmation,
          },
        },
      };

      const requestOptions = {
        headers: {
          Accept: "application/vnd.api+json",
          "Content-Type": "application/vnd.api+json",
        },
      };

      try {
        await this.$store.dispatch("register", { user, requestOptions });
        await this.$store.dispatch(
          "alerts/success",
          "Successfully registered."
        );
      } catch (e) {
        await this.$store.dispatch(
          "alerts/error",
          "Oops, 請填寫完整資料"
        );
        this.setApiValidation(e.response.data.errors);
      }
    },
  },
};
</script>
